export class MedicalDevice {
  dt?: string;
  firstname?: string;
  coding_id?: number;
  patient_id?: number;
  description?: string;
  version_id?: number;
  implant_date?: string;
  status?: number;
  lastname?: string;
  [key: string]: any;
}
